import ResumeLineDividerIconSVG from "assets/svg/resume-line-divider-icon";
import _ from "lodash";
import React from "react";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import { renderEndDate, renderStartDate } from "../../resume";
import MilestoneTG from "../../preview/template-four-tg/milestone";
import { QRResume_TEMP_4 } from "../../qr-code/qr-resume";
import { A4_SIZE } from "../../resume"; 

export default function TemplateFourFullPageTwo(props) {
  const {
    milestones = {},
    primaryColor,
    tertiaryColor,
    show_image_milestone = true,
    item,
    profile,
    page,
    totalPage,
    show_qr_milestone,
    show_qr_reels,
    milestone_position=[]
  } = props;

  return (
    <div className="w-full" style={A4_SIZE}>
      <div className="w-full bg-white h-full">
        {/* ouside padding */}
        <div className="w-full h-full template-four-two-padding-full">
          {/* inner padding */}
          <div className="w-full h-full grid p-3.5 relative grid-row-auto">
            {/* body start */}
            <div
              className="w-full flex flex-col gap-y-7">
                <MilestoneTG
                  items={item}
                  milestones={milestones}
                  primaryColor={primaryColor}
                  show_image_milestone={show_image_milestone}
                  tertiaryColor={tertiaryColor}
                  profile={profile}
                  fullPreview = {true} 
                  milestone_position={milestone_position}
                      />
                  {totalPage === page && 
                      <QRResume_TEMP_4 {...{show_qr_milestone,show_qr_reels}} />
                  }
            </div>
            {/* end */}
            {/* footer */}
            <div className="w-full flex items-end">
              <div className="w-full">
                <ResumeLineDividerIconSVG full={true} />
                <div className="w-full grid pt-3.5 justify-center">
                  <p className="text-xs text-resumeTempFourTextPrimary leading-4 opacity-90">
                    Page {page} of {totalPage}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
